import { Dialog, DialogTitle, DialogContent, Grid } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import { useForm } from "../../../hooks/useForm";
import { ConveniosNomencladosGalenoGastos } from "./ConveniosNomencladosGalenoGastos";
import { ConveniosNomencladosSeleccionarPracticas } from "./ConveniosNomencladosSeleccionarPracticas";
import { ConveniosNomencladosPrevisualizacion } from ".//ConveniosNomencladosPrevisualizacion";
import { ConveniosNomencladosPracticasActivas } from "./ConveniosNomencladosPracticasActivas";
import { setActivosPorFecha } from "../../../actions/contrataciones/contratacionesConvenios";
import { TIPO_PRACTICAS_POR_FECHA } from "../../../utils/constants";
import { useDispatch } from "react-redux";

export const ConveniosNomenclados = (props) => {
  const [openModalSelectorPracticas, setOpenModalSelectorPracticas] = useState(false);
  const [showPrevisualizacion, setShowPrevisualizacion] = useState(false);
  const dispatch= useDispatch()
  const initialValues = {
    idCategoria: "",
    fechaInicioVigencia: "",
    codDesde: null,
    codHasta: null,
    galenoQuirurgico: "",
    gastoQuirurgico: "",
    galenoRadiologico: "",
    gastoRadiologico: "",
    galenoEcografico: "",
    gastoEcografico: "",
    galenoTAC: "",
    gastoTAC: "",
    galenoUTI: "",
    gastoUTI: "",
    galenoBioquimico: "",
    gastoBioquimico: "",
    galenoConsulta: "",
    gastoUnidadPension: "",
    galenoPractica: "",
    otrosGastos: "",
  };

  const [
    formValues,
    handleInputChange,
    ,
    setearValor,
    ,
    ,
    ,
    ,
    setearVariosValores,
    ,
  ] = useForm(initialValues);

  const openModalPracticasHandler = () => {
    setOpenModalSelectorPracticas(true);
  };

  const closeModalPracticasHandler = () => {
    setOpenModalSelectorPracticas(false);
  };

  useEffect(() => {
    return () => {
      dispatch(setActivosPorFecha(TIPO_PRACTICAS_POR_FECHA.VIGENTES))
    }
  }, [])

  return (
    <React.Fragment>
      <Dialog
        fullWidth
        maxWidth="lg"
        open={openModalSelectorPracticas}
        onClose={closeModalPracticasHandler}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" style={{ paddingBottom: "0px" }}>
          {showPrevisualizacion
            ? "Confirmar Practicas Nomencladas"
            : "Ingreso Practicas Nomencladas"}
        </DialogTitle>
        <DialogContent>
          {showPrevisualizacion ? (
            <ConveniosNomencladosPrevisualizacion
              formValues={formValues}
              closeModalPracticasHandler={closeModalPracticasHandler}
              setShowPrevisualizacion={setShowPrevisualizacion}
            />
          ) : (
            <ConveniosNomencladosSeleccionarPracticas
              formValues={formValues}
              setearValor={setearValor}
              closeModalPracticasHandler={closeModalPracticasHandler}
              setShowPrevisualizacion={setShowPrevisualizacion}
            />
          )}
        </DialogContent>
      </Dialog>
      <Grid container spacing={2}>
        {!props.fieldsDisabled && <Grid item xs={3}>
          <ConveniosNomencladosGalenoGastos
            openModalPracticasHandler={openModalPracticasHandler}
            formValues={formValues}
            handleInputChange={handleInputChange}
            setearValor={setearValor}
            initialValues={initialValues}
            setearVariosValores={setearVariosValores}
            setShowPrevisualizacion={setShowPrevisualizacion}
            fieldsDisabled={props.fieldsDisabled}
          />
        </Grid>}
        <Grid item xs={!props.fieldsDisabled ? 9 : 12}>
          <ConveniosNomencladosPracticasActivas fieldsDisabled={props.fieldsDisabled} />
        </Grid>
      </Grid>
    </React.Fragment>
  );
};
